<template>
<div>
  <div class="zfw-header">
        <div class="header">
            <div class="zfw-logo">
                <a href="http://www.fangchan.com"><img src="../assets/images/zfw-logo.png" /></a>
            </div>
            <div class="zfw-nav">
                <ul>
                  <li><a target="_blank" href="http://www.fangchan.com/news/">新闻资讯</a></li>
                  <li><a target="_blank" href="http://www.fangchan.com/data/">数据研究</a></li>
                  <li><a target="_blank" href="http://www.fangchan.com/industry/">行业测评</a></li>
                  <li><a target="_blank" href="http://www.fangchan.com/prefecture/">房协专区</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="application-bg">
      <div class="application-banner">
        <!-- <img src="../assets/images/application-banner.png"  height="200"/> -->
        </div>
    </div>  

    <div class="grid-content bg-purple application-content">
    <h1>{{msg}}</h1>

    <el-form ref="form" :label-position="'right'" :model="info" label-width="100px">
      <el-form-item label="测评类型">
        <el-select style="width:100%" v-model="info.type" placeholder="请选择">
          <el-option label="中国房地产500强测评" value="1"></el-option>
          <el-option label="中国房地产上市公司测评" value="2"></el-option>
          <el-option label="中国房地产企业品牌价值测评" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="info.name" name="name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="企业名称">
        <el-input v-model="info.company" name="company" placeholder="请输入企业名称"></el-input>
      </el-form-item>
      <el-form-item label="职务">
        <el-input v-model="info.job" name="job" placeholder="请输入职务"></el-input>
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input v-model="info.phonenumber" name="phonenumber" placeholder="请输入联系方式"></el-input>
      </el-form-item>
      <el-form-item label="销售规模">
        <el-select style="width:100%" v-model="info.level" placeholder="请选择">
          <el-option label="500亿以上" value="500亿以上"></el-option>
          <el-option label="200~500亿" value="200~500亿"></el-option>
          <el-option label="100~200亿" value="100~200亿"></el-option>
          <el-option label="100亿以下" value="100亿以下"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="infoAdd">立即报名</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="list"
      style="width: 100%" align="left">
      <el-table-column
        label="会议类型"
        width="120">
        <template scope="scope">
                <span>{{scope.row.type | getTypeName}}</span>
        </template>
      </el-table-column>  
      <el-table-column
        prop="name"
        label="姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="company"
        label="企业名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="job"
        label="职务">
      </el-table-column>
      <el-table-column
        prop="phonenumber"
        label="电话"
        width="180">
      </el-table-column>
      <el-table-column
        prop="level"
        label="销售规模">
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="报名时间">
      </el-table-column>
    </el-table>
    </div>
</div>
</template>
<script>
export default {
  name: 'sublist',
  data () {
   return {
      msg: "测评申报",
      list:[],
      info:{
        name:'',
        company:'',
        job:'',
        phonenumber:'',
        level:'',
        type:'',
        updatedAt:'',
      }
    }
  },

  mounted: function(){
    this.$nextTick(function () {
      this.$http.get('/api/application/list').then(
        response => {
          console.log(response.body);
          this.list = response.body;
        },
        response => {
          console.log('failed');
        }
      )
    });
  },
  methods: {
    infoAdd() {
      this.$http.post('/api/application/register',this.info).then( 
        response => {
        if(response.ok){
            this.$message({
                showClose: true,
                message: '恭喜你，报名成功',
                type: 'success'
              });
              this.list.push(this.info);
              this.info = {};
            }
        },
        response => {
          console.log('failed');
        }
      )
    }       
            
  }

}



</script>



// WEBPACK FOOTER //
// src/components/ApplicationList.vue